import script from "./FormTouch.vue?vue&type=script&setup=true&lang=js"
export * from "./FormTouch.vue?vue&type=script&setup=true&lang=js"

import "./FormTouch.vue?vue&type=style&index=0&id=0bb6e52c&lang=scss"

const __exports__ = script;

export default __exports__